module.exports = __webpack_public_path__ + "fonts/icons.woff"


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-css/themes/default/assets/fonts/icons.woff
 ** module id = 384
 ** module chunks = 0
 **/